<template>
  <div class="navbar navbar_class">
      <el-row style="height:95px;overflow: hidden;" class="headerContainer">
        <el-col :span="5">
          <el-image
            class="logo"
            v-if="logo_img !=''"
            :src="logo_img">
          </el-image>
          &nbsp;
        </el-col>
        <el-col :span="19" style="display: flex;">
          <template v-if="$Base64.decode($ls.get($getKeyInfo('userType'))) == 2 && headList.length <= 0">
            <div class="classHerad">&nbsp;</div>
          </template>
          <div :class="(onIndex == 5?'on':'') + ' classHerad'" @click="jumpPage(5)" v-if="$Base64.decode($ls.get($getKeyInfo('userType'))) == 1">
            <router-link :to="{path:'AssetAllocation'}">
              <el-image class="menu_img" :src="zichang"></el-image>
              <span>资产配置</span>
            </router-link>
          </div>
          <div :class="(onIndex == 6?'on':'') + ' classHerad'" @click="jumpPage(6)">
            <router-link :to="{path:'CourseCenter'}">
              <el-image class="menu_img" :src="kecheng2"></el-image>
              <span>课程中心</span>
            </router-link>
          </div>
          <div :class="(onIndex == 7?'on':'') + ' classHerad'" @click="jumpPage(7)">
            <router-link :to="{path:'MyAppsCenter'}">
              <el-image class="menu_img" :src="yingyongzx"></el-image>
              <span>应用中心</span>
            </router-link>
          </div>
          <div :class="(onIndex == 11?'on':'') + ' classHerad'" @click="jumpPage(11)">
            <router-link :to="{path:'algclargemodel'}">
              <el-image class="menu_img" :src="algc"></el-image>
              <span>AlGC大模型</span>
            </router-link>
          </div>
          <div :class="(onIndex == 8?'on':'') + ' classHerad'" @click="jumpPage(8)">
            <router-link :to="{path:$Base64.decode($ls.get($getKeyInfo('userType'))) == 1?'Coach':'TCoach'}">
              <el-image class="menu_img" :src="kaozheng"></el-image>
              <span>考证辅导</span>
            </router-link>
          </div>
          <div :class="(onIndex == 9?'on':'') + ' classHerad'" @click="jumpPage(9)" v-if="$Base64.decode($ls.get($getKeyInfo('userType'))) == 1">
            <router-link :to="{path:'ContestList'}">
              <el-image class="menu_img" :src="jingsai"></el-image>
              <span>竞赛中心</span>
            </router-link>
          </div>
          <div :class="(onIndex == 10?'on':'') + ' classHerad'" @click="jumpPage(10)">
            <router-link :to="{path:'ThirdParty'}">
              <el-image class="menu_img" :src="dsfyingyong"></el-image>
              <span>第三方应用</span>
            </router-link>
          </div>         
          <template v-for="(item, index) in headList">
            <div class="classHerad">
              <a :href="item.studentClientLinkContent" target="_blank">
                <el-image class="menu_img" :src="$isHttp(item.studentClientLinkImg)"></el-image>
                <span :style="classInfo" class="limit_line_one">{{item.studentClientLinkTitle}}</span>
              </a>
            </div>
          </template>
          <div class="classHerad" style="cursor: pointer;text-align: right;">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link" style="margin-right: 0;color: #ffffff;width: auto;max-width: 150px;">
                <el-image class="menu_img" style="width: 30px;height: 30px;;margin: 10px 10px 0;border-radius: 50%;" :src="yonghu"></el-image>
                <span class="limit_line_one" style="float: left;max-width: 80px;min-width: 50px;">{{userInfo.name}}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="quit">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
            <!-- <ul>
              <li :class="onIndex == 5?'on':''" @click="jumpPage(5)" v-if="$Base64.decode($ls.get($getKeyInfo('userType'))) == 1">
                <router-link :to="{path:'AssetAllocation'}">
                  <el-image class="menu_img" :src="zichang"></el-image>
                  <span>资产配置</span>
                </router-link>
              </li>
              <li :class="onIndex == 6?'on':''" @click="jumpPage(6)">
                <router-link :to="{path:'CourseCenter'}">
                  <el-image class="menu_img" :src="kecheng2"></el-image>
                  <span>课程中心</span>
                </router-link>
              </li>
              <li :class="onIndex == 7?'on':''" @click="jumpPage(7)">
                <router-link :to="{path:'MyAppsCenter'}">
                  <el-image class="menu_img" :src="yingyongzx"></el-image>
                  <span>应用中心</span>
                </router-link>
              </li>
              <li :class="onIndex == 8?'on':''" @click="jumpPage(8)">
                <router-link :to="{path:$Base64.decode($ls.get($getKeyInfo('userType'))) == 1?'Coach':'TCoach'}">
                  <el-image class="menu_img" :src="kaozheng"></el-image>
                  <span>考证辅导</span>
                </router-link>
              </li>
              <li :class="onIndex == 9?'on':''" @click="jumpPage(9)" v-if="$Base64.decode($ls.get($getKeyInfo('userType'))) == 1">
                <router-link :to="{path:'ContestList'}">
                  <el-image class="menu_img" :src="jingsai"></el-image>
                  <span>竞赛中心</span>
                </router-link>
              </li>
              <li :class="onIndex == 10?'on':''" @click="jumpPage(10)">
                <router-link :to="{path:'ThirdParty'}">
                  <el-image class="menu_img" :src="dsfyingyong"></el-image>
                  <span>第三方应用</span>
                </router-link>
              </li>
              <template v-for="(item, index) in headList">
                <li>
                  <router-link :href="item.studentClientLinkContent" to="" target="_blank">
                    <el-image class="menu_img" :src="$isHttp(item.studentClientLinkImg)"></el-image>
                    <span :style="classInfo" class="limit_line_one">{{item.studentClientLinkTitle}}</span>
                  </router-link>
                </li>
              </template>
              <li :class="onIndex == 10?'on':''" @click="jumpPage(10)" style="float: right;cursor: pointer;">
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link" style="margin-right: 0;color: #ffffff;width: 120;">
                    <el-image class="menu_img" style="width: 30px;height: 30px;;margin: 10px 10px 0;border-radius: 50%;" :src="yonghu"></el-image>
                    {{userInfo.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="quit">退出</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
            </ul> -->
        </el-col>
      </el-row>
  </div>
</template>

<script>
import logo_img from '@/images/index/logo@2x.png';
import zichang from '@/images/index/zichang@2x.png';
import jingsai from '@/images/index/jingsai@2x.png';
import kaozheng from '@/images/index/kaozheng@2x.png';
import dsfyingyong from '@/images/index/dsfyingyong@2x.png';
import yingyongzx from '@/images/index/yingyongzx@2x.png';
import kecheng2 from '@/images/index/kecheng@2x.png';
import algc from '@/images/index/metaso-ai-search-icon.png';
export default {
  name: 'Navbar',
  data() {
    return {
      logo_img:logo_img,
      yingyongzx:yingyongzx,
      zichang:zichang,
      jingsai:jingsai,
      dsfyingyong:dsfyingyong,
      algc:algc,
      yonghu:this.$getHeadImg(),
      onIndex:0,
      userInfo:this.$ls.get(this.$getKeyInfo("userInfo")) || {},
      kaozheng:kaozheng,
      kecheng2:kecheng2,
      headList:[],
      classInfo:""
    }
  },
  created() {
    this.getUniInfo();
    this.getInfo();
    // if(this.$Base64.decode(this.$ls.get(this.$getKeyInfo('userType'))) == 2){
    //   this.getInfo();
    // }
  },
  methods: {
    jumpPage(index){ //控制用户点击菜单显示
      this.onIndex = index;
      this.$emit('updateDate','navbar');
    },
    getUniInfo(){ //获取logo
      this.$get("/api/base/getUniInfo.do").then((ret)=>{
        if(!this.$isEmpty(ret.data.universitiesCollegesLogo)){
          this.logo_img = this.$isHttp(ret.data.universitiesCollegesLogo);
        }
      });
    },
    getInfo(){
      //获取头部
      this.$get("/api/studentClientLink/getList.do",{studentClientLinkType:"LOGINED_NAV",studentClientLinkStatus:1}).then((ret)=>{
        if(ret.code == 0){
          if(this.$Base64.decode(this.$ls.get(this.$getKeyInfo('userType'))) == 2){
            this.headList = ret.data.splice(0,4);
          }else{
            this.headList = ret.data.splice(0,2);
          }
        }
      });
    },
    handleCommand(command) {
      if(command == "quit"){
        this.quit();
      }
    },
    quit(){ //退出
      this.$confirm('是否确定退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/logout.json").then((ret) => {
          if(ret.code == 0){
            this.$message({
              message: "退出成功！",
              type: 'success'
            });
            this.$removeToken();
            this.$ls.set(this.$getKeyInfo("advTime"),null);
            // this.$ls.clear();
            window.location.href = window.location.origin + '/Login';
          }
        });
      }).catch(() => {

      });
    },
  }
}
</script>

<style lang="less">
  .navbar_class{
    .classHerad{
      justify-content:space-between;width: 100%;
    }

    .on span{
      color: #409EFF !important;
    }
    .classHerad span:hover{
      color: #409EFF !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue